import $ from 'jquery'
import Swiper from 'swiper'
import {Pagination, Autoplay} from 'swiper/modules';

$('.slider-integrated .swiper').each(function () {

  /*******************************
   * Swiper Initialization
   ******************************/

  let swiper = new Swiper(this, {
    modules: [Pagination, Autoplay],
    autoHeight: true,
    // TODO: check lazy load mechanism
    lazy: {
      loadOnTransitionStart: false,
      loadPrevNext: true,
    },
    on: {
      slideChange: function (swiper) {
        swiper.slides.forEach(function (slide) {
          const background = slide.getAttribute('data-background');
          if (background && !slide.style.backgroundImage) {
            slide.style.backgroundImage = `url(${background})`;
          }
        });
      },
    },
    ...$(this).data('options')
  })

  $(this).find('.swiper-button-next').on('click', function () {
    swiper.slideNext()
  })

  $(this).find('.swiper-button-prev').on('click', function () {
    swiper.slidePrev()
  })

  /*******************************
   * Countdown
   ******************************/

  $(this).find('.slider-countdown').each(function () {
    let $countdown = $(this)
    let $ancestor = $countdown.closest('[data-countdown]')

    let date = $ancestor.data('countdown')
    let timestamp = $ancestor.data('countdown-ms')

    if (typeof timestamp !== 'number') return

    let browserDate = new Date(date)
    let diff = timestamp - browserDate.getTime()

    let remainingMs = timestamp - Date.now() - diff

    let assembleCountdownHtml = () => {
      remainingMs = timestamp - Date.now() - diff

      let days = Math.floor(remainingMs / (1000 * 60 * 60 * 24))
      let hours = Math.floor((remainingMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((remainingMs % (1000 * 60)) / 1000)

      let html = ''

      let showDays = days > 0
      if (showDays) {
        html +=
          `<span class="countdown-value">${String(days).padStart(2, '0')}</span>` +
          `<span class="countdown-label">Tage</span>` +
          `<span class="countdown-colon">:</span>`
      }

      let showHours = hours > 0 || showDays
      if (showHours) {
        html +=
          `<span class="countdown-value">${String(hours).padStart(2, '0')}</span>` +
          `<span class="countdown-label">Stunden</span>` +
          `<span class="countdown-colon">:</span>`
      }

      let showMinutes = minutes > 0 || showHours
      if (showMinutes) {
        html +=
          `<span class="countdown-value">${String(minutes).padStart(2, '0')}</span>` +
          `<span class="countdown-label">Minuten</span>` +
          `<span class="countdown-colon">:</span>`
      }

      let showSeconds = seconds > 0 || showMinutes
      if (showSeconds) {
        html +=
          `<span class="countdown-value">${String(seconds).padStart(2, '0')}</span>` +
          `<span class="countdown-label">Sekunden</span>`
      }

      return html
    }

    let intervalId = setInterval(() => {
      let html = assembleCountdownHtml()

      if (remainingMs <= 0) {
        clearInterval(intervalId)
        swiper.removeSlide($countdown.closest('.swiper-slide').data('swiper-slide-index'))
      } else {
        $countdown.html(html)
      }
    }, 1000)
    $countdown.html(assembleCountdownHtml())
  })

})
